import { Mutation, Action, VuexModule, Module } from "vuex-module-decorators";

/** store state model */
export interface MobileOtherUserReplyReceiveMessageState {
  /** 本文 */
  text: string;
  /** 添付ファイル */
  files: Array<File>;
  /** メンバー電話番号 */
  otherUserGroupMemberTel: string;
  /** メンバー所属 */
  otherUserGroupMemberOrganization: string;
  /** 受信者 */
  receiver: string;
  /** 値が格納してあるか */
  exist: boolean;
}

/**
 * ### mobileOtherUserReplyReceiveMessage store
 *
 * - store
 *   - 新規送信画面の入力情報を保持する
 * - action, mutation
 *   - 新規送信画面の入力情報を格納する
 */
@Module({ name: "mobileOtherUserReplyReceiveMessage" })
export default class mobileOtherUserReplyReceiveMessage extends VuexModule implements MobileOtherUserReplyReceiveMessageState {
  text = "";
  files = [];
  otherUserGroupMemberTel = "";
  otherUserGroupMemberOrganization = "";
  receiver = "";
  exist = false;

  /** stateのgetters */
  get mobileOtherUserReplyReceiveMessageState(): MobileOtherUserReplyReceiveMessageState {
    const state: MobileOtherUserReplyReceiveMessageState = {
      text: this.text,
      files: this.files,
      otherUserGroupMemberTel: this.otherUserGroupMemberTel,
      otherUserGroupMemberOrganization: this.otherUserGroupMemberOrganization,
      receiver: this.receiver,
      exist: this.exist
    };
    return state;
  }

  @Mutation
  private SET_MOBILE_OTHER_USER_REPLY_RECEIVE_MESSAGE_STATE(state: MobileOtherUserReplyReceiveMessageState) {
    this.text = state.text;
    this.files = state.files as never[];
    this.otherUserGroupMemberTel = state.otherUserGroupMemberTel;
    this.otherUserGroupMemberOrganization = state.otherUserGroupMemberOrganization;
    this.receiver = state.receiver;
    this.exist = true;
    return;
  }

  @Mutation
  private RESET_MOBILE_OTHER_USER_REPLY_RECEIVE_MESSAGE_STATE() {
    this.text = "";
    this.files = [];
    this.otherUserGroupMemberTel = "";
    this.otherUserGroupMemberOrganization = "";
    this.receiver = "";
    this.exist = false;
    return;
  }

  /**
   * ### 受信メッセージの返信画面の入力情報を更新する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public updateMobileOtherUserReplyReceiveMessage(payload: { state: MobileOtherUserReplyReceiveMessageState }): void {
    this.SET_MOBILE_OTHER_USER_REPLY_RECEIVE_MESSAGE_STATE(payload.state);
    return;
  }

  /**
   * ### 受信メッセージの返信画面の入力情報を初期化する
   *
   * @param payload Actionは第一引数でしか値を渡せないので引数をまとめたオブジェクト
   */
  @Action({ rawError: true })
  public resetMobileOtherUserReplyReceiveMessage(): void {
    this.RESET_MOBILE_OTHER_USER_REPLY_RECEIVE_MESSAGE_STATE();
    return;
  }
}
